<template>
  <div class="terms">
    <div>
      <p
        id="linkclose"
        class="float-right font-weight-bold terms__go-back"
        @click="goBack"
      >
        &times;
      </p>
    </div>
    <div class="container pt-2 text-justify">
      <!-- eslint-disable vue/no-v-html -->
      <div
        class="markdown"
        :class="{'upper-alpha first-li-strong' : country.pais === 'CR' }"
        v-html="compiledMarkdown"
      ></div>
      <div>
        <button
          id="linkreturn"
          class="button grey-button w-100"
          @click="goBack"
        >
          {{ $t('text.goBack') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import marked from 'marked';

import i18n from './i18n';

export default {
  name: 'Terms',
  beforeRouteLeave(to, _, next) {
    if (to.name === 'Terms') this.$router.go(-1);
    else next();
  },
  computed: {
    ...mapGetters(['country']),
    compiledMarkdown() {
      return marked(i18n[this.country.pais](), { headerIds: false });
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss">
.terms {
  * {
    text-align: justify;
  }

  &__go-back {
    font-size: 30px;
    cursor: pointer;
    margin-right: 1rem;
  }

  &__title {
    font-size: 2rem;
    margin-bottom: 1.5rem;
    text-align: left;
  }
  h2 {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.5rem;
    text-align: left;
  }

  ul {
    list-style-type: lower-alpha;
    li ul {
      list-style-type: circle;
    }
  }

  ul li p {
    margin-top: .5rem;
    margin-bottom: .5rem
  }

  .upper-alpha ul {
    list-style-type: upper-alpha;
    li ul {
      list-style-type: circle;
    }
    li ol {
      list-style-type: lower-alpha;
    }
  }

  .first-li-strong > ul:first-of-type > li:first-of-type {
    font-weight: bold;
  }

  .button {
    text-align: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}
</style>
